const LYON_FAQ = {
  shipping: { q: ['shipping','ship','delivery','deliver','how long','when will','tracking','track'], a: 'We ship Canada-wide from Cranbrook, BC. Shipping is a tiered flat rate — about $45 on orders $250+, and $65–$95 on smaller orders depending on province. We don\'t offer free shipping. Everything is built to order, so allow 7–14 business days (14–21 for custom colours). You\'ll get a tracking number once your order ships.' },
  colors: { q: ['color','colour','custom color','custom colour','powder coat','prismatic','what colors','what colours'], a: 'Every product can be powder coated in any Prismatic Powders colour. Standard options are Black, White, Neon Green, Hot Pink, Purple, and Electric Blue. Want something custom? Just ask — we can match almost anything.' },
  pricing: { q: ['price','cost','how much','pricing','quote','blasting price','powder coat price'], a: 'Product pricing is listed on each product page. For powder coating and media blasting services, rates start at $200/hr with a $100 minimum. Request a custom quote through our Services page.' },
  hours: { q: ['hours','open','when are you','business hours','schedule','closed'], a: 'We’re open Monday–Friday, 8 AM – 5 PM MST. Located in Cranbrook, BC. Closed weekends and holidays.' },
  location: { q: ['where','location','address','find you','visit','cranbrook'], a: 'We’re in Cranbrook, BC in the Kootenays. Visit our Contact page for the full address and a map.' },
  returns: { q: ['return','refund','exchange','warranty','broken','damaged'], a: 'We stand behind everything we build. If something arrives damaged, contact us immediately with photos and we’ll make it right. Check our Shipping & Returns policy for full details.' },
  materials: { q: ['material','aluminum','aluminium','steel','what are','made of','6063'], a: 'Our bumpers are precision TIG-welded 6063 aluminum — chosen for superior energy absorption. They flex on impact instead of shattering, making them repairable after hard hits.' },
  install: { q: ['install','installation','how to install','video','instructions','mount','fit'], a: 'Most of our products have install videos on their product pages from Remer’s Renderings. Basic hand tools are all you need — no drilling or modification required for most models.' },
  brands: { q: ['brand','polaris','ski-doo','skidoo','arctic cat','yamaha','lynx','what sleds','snowmobile'], a: 'We make bumpers for Polaris (Matryx, Axys), Ski-Doo (Gen 4, Gen 5), Arctic Cat (Catalyst, Ascender, Pro Climb), Yamaha (Sidewinder), and Lynx (Shredder). Check our Snowmobile collection for your model.' },
  smokers: { q: ['smoker','drum smoker','bbq','grill','cooking','outdoor cooking','fire pit'], a: 'Our handcrafted drum smokers are built for real fire cooking. Available in Black, Red, and Blue powder coat. Check out the Outdoor Cooking collection for all our BBQ gear.' },
  services: { q: ['service','blasting','stripping','media blast','sandblast','powder coat service'], a: 'We offer media blasting, chemical stripping, and powder coating services. Bring your parts to our Cranbrook shop or ship them in. Get a quote on our Services page.' },
  custom: { q: ['custom','custom build','fabrication','fabricate','weld','welding','one-off'], a: 'Got something specific in mind? We do custom fabrication and welding. Reach out through our Contact page with details and we’ll see what we can build for you.' }
};

function lyonFaqMatch(msg) {
  const lower = msg.toLowerCase();
  let best = null;
  let bestScore = 0;
  for (const [, faq] of Object.entries(LYON_FAQ)) {
    let score = 0;
    for (const keyword of faq.q) {
      if (lower.includes(keyword)) score += keyword.length;
    }
    if (score > bestScore) {
      bestScore = score;
      best = faq;
    }
  }
  return best ? best.a : null;
}

(function() {
  const PROXY_URL = window.lyonChatbotProxy || null;

  // Owner-editable strings from the theme customizer (Theme settings › Chatbot),
  // injected as window.LYON_CHAT_CONFIG before this script. Every field falls
  // back to the original hardcoded default so the widget is unchanged if the
  // config is absent (e.g. older cached layout).
  const CFG = window.LYON_CHAT_CONFIG || {};
  const TEXT = {
    promptBubble: CFG.promptBubble || 'Have any questions?',
    welcome: CFG.welcome || 'Hey! Welcome to Lyon Built. Ask me anything about our snowmobile bumpers, smokers, powder coating, or services.',
    placeholder: CFG.placeholder || 'Type a message...',
    disclosure: CFG.disclosure || '',
    knowledge: CFG.knowledge || ''
  };
  const SUGGESTED = (typeof CFG.suggestedQuestions === 'string' ? CFG.suggestedQuestions : '')
    .split('\n')
    .map(function(s) { return s.trim(); })
    .filter(function(s) { return s.length > 0; });

  // Stable id + start time for this page-session's conversation. Sent with every
  // proxy request so the portal upserts all turns into one row (real-time log).
  const CONVERSATION_ID = (self.crypto && crypto.randomUUID)
    ? crypto.randomUUID()
    : 'c-' + Date.now() + '-' + Math.random().toString(36).slice(2);
  const STARTED_AT = new Date().toISOString();

  function createChatbot() {
    const wrapper = document.createElement('div');
    wrapper.id = 'lyon-chatbot';
    // Static markup only (SVGs, structure). All owner-editable strings are set
    // via textContent below so nothing from the config is ever parsed as HTML.
    wrapper.innerHTML = `
      <div id="lyon-chat-prompt" class="lyon-hidden">
        <span id="lyon-chat-prompt-text"></span>
        <button id="lyon-chat-prompt-close" aria-label="Dismiss">&times;</button>
      </div>
      <button id="lyon-chat-toggle" aria-label="Chat with us">
        <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>
        </svg>
      </button>
      <div id="lyon-chat-panel" class="lyon-chat-hidden" role="dialog" aria-label="Chat with Lyon Built" aria-hidden="true">
        <div id="lyon-chat-header">
          <div id="lyon-chat-header-info">
            <span id="lyon-chat-header-name">Lyon Built</span>
            <span id="lyon-chat-header-status">Typically replies instantly</span>
          </div>
          <button id="lyon-chat-close" aria-label="Close chat">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><path d="M18 6L6 18M6 6l12 12"/></svg>
          </button>
        </div>
        <div id="lyon-chat-messages"></div>
        <form id="lyon-chat-form">
          <input id="lyon-chat-input" type="text" autocomplete="off">
          <button type="submit" id="lyon-chat-send" aria-label="Send">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><path d="M22 2L11 13M22 2l-7 20-4-9-9-4z"/></svg>
          </button>
        </form>
      </div>
    `;
    document.body.appendChild(wrapper);

    const toggle = document.getElementById('lyon-chat-toggle');
    const panel = document.getElementById('lyon-chat-panel');
    const close = document.getElementById('lyon-chat-close');
    const form = document.getElementById('lyon-chat-form');
    const input = document.getElementById('lyon-chat-input');
    const messages = document.getElementById('lyon-chat-messages');
    const prompt = document.getElementById('lyon-chat-prompt');
    const promptText = document.getElementById('lyon-chat-prompt-text');
    const promptClose = document.getElementById('lyon-chat-prompt-close');

    // Populate the owner-editable strings as inert text.
    promptText.textContent = TEXT.promptBubble;
    input.placeholder = TEXT.placeholder;

    // Disclosure line, shown before the welcome so the visitor sees it first.
    if (TEXT.disclosure) {
      const disc = document.createElement('div');
      disc.className = 'lyon-chat-disclosure';
      disc.setAttribute('role', 'note');
      disc.textContent = TEXT.disclosure;
      messages.appendChild(disc);
    }

    // Welcome message (bot bubble).
    (function() {
      const welcome = document.createElement('div');
      welcome.className = 'lyon-chat-msg lyon-chat-bot';
      const p = document.createElement('p');
      p.textContent = TEXT.welcome;
      welcome.appendChild(p);
      messages.appendChild(welcome);
    })();

    // Suggested-question chips. Tapping one fills the input and focuses it so the
    // visitor can send (or edit) it. Removed once the conversation gets going.
    let chipsEl = null;
    if (SUGGESTED.length) {
      chipsEl = document.createElement('div');
      chipsEl.className = 'lyon-chat-chips';
      SUGGESTED.forEach(function(q) {
        const chip = document.createElement('button');
        chip.type = 'button';
        chip.className = 'lyon-chat-chip';
        chip.textContent = q;
        chip.addEventListener('click', function() {
          input.value = q;
          input.focus();
        });
        chipsEl.appendChild(chip);
      });
      messages.appendChild(chipsEl);
    }

    function removeChips() {
      if (chipsEl && chipsEl.parentNode) {
        chipsEl.parentNode.removeChild(chipsEl);
        chipsEl = null;
      }
    }

    function hidePrompt() {
      if (prompt) prompt.classList.add('lyon-hidden');
    }

    setTimeout(() => {
      if (prompt && panel.classList.contains('lyon-chat-hidden')) {
        prompt.classList.remove('lyon-hidden');
      }
    }, 5000);

    if (prompt) prompt.addEventListener('click', (e) => {
      if (e.target === promptClose || e.target.closest('#lyon-chat-prompt-close')) {
        e.stopPropagation();
        hidePrompt();
        return;
      }
      hidePrompt();
      panel.classList.remove('lyon-chat-hidden');
      toggle.classList.add('lyon-chat-open');
      input.focus();
    });

    toggle.addEventListener('click', () => {
      hidePrompt();
      panel.classList.toggle('lyon-chat-hidden');
      toggle.classList.toggle('lyon-chat-open');
      const isOpen = !panel.classList.contains('lyon-chat-hidden');
      panel.setAttribute('aria-hidden', !isOpen);
      if (isOpen) input.focus();
    });
    close.addEventListener('click', () => {
      panel.classList.add('lyon-chat-hidden');
      toggle.classList.remove('lyon-chat-open');
      panel.setAttribute('aria-hidden', 'true');
      toggle.focus();
    });

    function addMessage(text, isBot) {
      // `text` is the visitor's own typed message or the AI proxy's reply — never
      // trusted markup. Build the DOM with text nodes so nothing in it is ever
      // parsed as HTML; the \n -> <br> line-break behaviour is kept by inserting
      // real <br> elements between the (inert) lines.
      const div = document.createElement('div');
      div.className = 'lyon-chat-msg ' + (isBot ? 'lyon-chat-bot' : 'lyon-chat-user');
      const p = document.createElement('p');
      String(text).split('\n').forEach((line, i) => {
        if (i > 0) p.appendChild(document.createElement('br'));
        p.appendChild(document.createTextNode(line));
      });
      div.appendChild(p);
      messages.appendChild(div);
      messages.scrollTop = messages.scrollHeight;
      return div;
    }

    function showTyping() {
      const div = document.createElement('div');
      div.className = 'lyon-chat-msg lyon-chat-bot lyon-chat-typing';
      div.innerHTML = '<p><span class="lyon-dot"></span><span class="lyon-dot"></span><span class="lyon-dot"></span></p>';
      messages.appendChild(div);
      messages.scrollTop = messages.scrollHeight;
      return div;
    }

    async function getAIResponse(userMsg, history) {
      if (!PROXY_URL) return null;
      try {
        const res = await fetch(PROXY_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            message: userMsg,
            history: history.slice(-10),
            conversationId: CONVERSATION_ID,
            startedAt: STARTED_AT,
            context: TEXT.knowledge || undefined
          })
        });
        if (!res.ok) return null;
        const data = await res.json();
        return data.reply || null;
      } catch { return null; }
    }

    const history = [];

    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const text = input.value.trim();
      if (!text) return;
      input.value = '';
      removeChips();
      addMessage(text, false);
      history.push({ role: 'user', content: text, at: new Date().toISOString() });

      const typing = showTyping();

      let reply = null;
      if (PROXY_URL) {
        reply = await getAIResponse(text, history);
      }
      if (!reply) {
        reply = lyonFaqMatch(text);
      }
      if (!reply) {
        reply = 'Good question! I don\'t have a specific answer for that. You can reach us directly at our Contact page or call during business hours (Mon–Fri, 8 AM–5 PM MST).';
      }

      typing.remove();
      addMessage(reply, true);
      history.push({ role: 'assistant', content: reply, at: new Date().toISOString() });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', createChatbot);
  } else {
    createChatbot();
  }
})();
